<template>
    <v-stepper-content step="1">
        <v-form ref="form_datos_generales">
            <v-container fluid grid-list-md>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="objeto.idAseguradora"
                            :items="listGeneral.listAseguradoras" @change="onListarSeguro" item-value="idAseguradora"
                            item-text="aseguradora" :rules="requeridoRegla" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="objeto.idSeguro"
                            :items="listGeneral.listaSegurosModal"
                            @change="onListarPoliza($event);verificarTipoSeguro($event)" item-text="seguro"
                            item-value="idSeguro" :rules="requeridoRegla" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Póliza *" color="textbox" v-model="objeto.idPoliza"
                            :items="listGeneral.listaPolizasModal" item-value="idPoliza" item-text="poliza"
                            :rules="requeridoRegla" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="8">
                        <v-text-field label="Nombre del Producto *" color="textbox" v-model="objeto.producto"
                            :rules="_.concat(requeridoRegla,soloLetrasRegla(1,objeto.producto,300))" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-row dense>
                            <v-col cols="2" sm="1">
                                <v-tooltip right color="primary">
                                    <template v-slot:activator="{ on }">
                                        <v-icon class="mt-3" color="primary" @click="abrirVentana"
                                            v-html="'cloud_upload'" v-on="on" />
                                        <input type="file" style="display: none;" ref="icono" @change="obtenerFile"
                                            accept="image/gif, image/jpeg, image/png" />
                                    </template>
                                    <span>Subir Icono</span>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="10" sm="11">
                                <div class="text-center" v-show="_.size(objeto.logo)">
                                    <img :src="objeto.logo" width="15%" alt="...">
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="12">
                        <v-textarea label="Descripción del Producto " color="textbox" no-resize
                            v-model="objeto.descripcion" :value="objeto.descripcion" counter="300" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense align-content="space-between" :row="$root.isTouch" :wrap="$root.isTouch">
                    <v-col>
                        <v-autocomplete label="Estado *" color="textbox" v-model="objeto.idEstado"
                            :items="listGeneral.listaEstados" item-value="id_estado" item-text="nombre_estado"
                            outlined dense />
                    </v-col>
                    <v-col>
                        <v-text-field label="Meses hasta diferir póliza *" color="textbox"
                            v-model="objeto.mesesDiferidoPrima"
                            :rules="_.concat(requeridoRegla,soloNumerosRegla(1,objeto.mesesDiferidoPrima,2))" outlined dense />
                    </v-col>
                    <v-col v-show="parseInt(objeto.idSeguro) == parseInt(parametros.idSeguroVehiculo)">
                        <v-checkbox label="Producto con Vehículo a Crédito" color="primary"
                            v-model="objeto.idVehiCredi" dense/>
                    </v-col>
                    <v-col v-show="objDatosGenerales.condiciones">
                        <v-switch color="primary" label="Declaración de Asegurabilidad"
                            v-model="objeto.declaracionAsegurabilidad" dense/>
                    </v-col>
                    <v-col v-show="objDatosGenerales.condiciones">
                        <v-switch color="primary" label="Permite Agregar Beneficiarios"
                            v-model="objeto.agregarBeneficios" dense/>
                    </v-col>
                    <v-col cols="1" v-show="false">
                        <v-tooltip top color="primary">
                            <template v-slot:activator="{ on }">
                                <v-icon v-show="objeto.agregarBeneficios" class="mt-3" color="primary"
                                    v-html="'visibility'" v-on="on" />
                            </template>
                            <span>Ver beneficios Complementarios</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col class="text-right">
                        <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-stepper-content>
</template>
<script>
    export default {
        // props: ['cargar', 'listGeneral', 'objForm', 'parametros', 'paso'],
        props:{
            cargar:{
                type: Boolean,
                default: false
            },
            listGeneral: {
                type: Object,
                default:{}
            },
            objForm: {
                type: Object,
                default:{}
            },
            parametros: {
                type: Object,
                default:{}
            }
        },
        inject: ['next', 'onListar'],
        data() {
            return {
                urlImage: null,
                objeto: {},
                objDatosGenerales: {
                    titulo: 'Beneficios Complementarios',
                    abrirModal: false,
                    abrirModalAgregar: false,
                    tituloModal: 'Nuevo Beneficio Complementario',
                    condiciones: false,
                    idEstado: '1',
                    idEstadoBusqueda: '1',
                    clonar: false
                }
            }
        },
        created(){
            this.objeto = {};
            this.objForm.titulo = 'Beneficio Complementario';
            this.objeto = {
                'condiciones': false,
                'radios': 'radio-1',
                'idEstado': _.toString(this.parametros.idEstadoDefault)
            };

            if (!_.isUndefined(this.objForm.idProducto)) {
                this.objeto = _.merge({}, this.objForm, this.objeto);

                this.onListarSeguro('L')
                    .then((respuesta) => {
                        return this.verificarTipoSeguro('L');
                    })
                    .then((respuesta) => {
                        return this.onListarPoliza('L');
                    }).then((respuesta) => {
                        this.$refs.form_datos_generales.resetValidation();
                        if (_.size(this.objeto.path) > 0)
                            this.onListarIcono('L');
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E')
                    });
            }
        },
        watch:{
            cargar:{
                handler(val,oldVal){
                    this.objeto = {};
                    if(val){
                        this.objForm.titulo = 'Beneficio Complementario';
                        this.objeto = {
                            'condiciones': false,
                            'radios': 'radio-1',
                            'idEstado': _.toString(this.parametros.idEstadoDefault)
                        };
    
                        if (!_.isUndefined(this.objForm.idProducto)) {
                            this.objeto = _.merge({}, this.objForm, this.objeto);
    
                            this.onListarSeguro('L')
                                .then((respuesta) => {
                                    return this.verificarTipoSeguro('L');
                                })
                                .then((respuesta) => {
                                    return this.onListarPoliza('L');
                                }).then((respuesta) => {
                                    this.$refs.form_datos_generales.resetValidation();
                                    if (_.size(this.objeto.path) > 0)
                                        this.onListarIcono('L');
                                })
                                .catch((e) => {
                                    mensajesAlerta(e, 'E')
                                });
                        }
                    }

                    if(!_.isUndefined(this.$refs.form_datos_generales))
                        this.$refs.form_datos_generales.resetValidation();
                },
                deep: true
            }
        },
        methods: {
            onListarSeguro(event) {
                if (!_.isUndefined(event)) {
                    this.$set(this.listGeneral, 'listaSegurosModal', []);
                    var error = 'E';
                    var objeto = {
                        opcion: 'L_SEGURO',
                        idAseguradora: _.get(this.objeto, 'idAseguradora', null),
                        idEstado: this.parametros.idEstadoDefault
                    };
                    var p = this.onListar(`administrador/producto/listar`, objeto)
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            this.$set(this.listGeneral, 'listaSegurosModal', respuesta.data.data);
                            return respuesta;
                        });

                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e || e.message, error);
                        });

                    return p;
                }
            },
            verificarTipoSeguro(event) {
                if (!_.isUndefined(event)) {
                    var error = 'E';
                    var objeto = {
                        'opcion': 'L',
                        'idSeguro': _.get(this.objeto, 'idSeguro', null),
                        'idEstado': _.get(this.objeto, 'idEstado', null)
                    };
                    var p = this.onListar(`administrador/seguro/listar`, objeto)
                        .then((respuesta) => {
                            if (_.size(respuesta.data.data) == 0) {
                                error = 'I';
                                throw respuesta.data.mensaje;
                            }
                            var r = parseInt(respuesta.data.data[0].idNaturaleza) == parseInt(this.parametros
                                .idNaturalezaPersona) ? true : false;
                            this.$set(this.objDatosGenerales, 'condiciones', r);
                            return respuesta;
                        });

                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e || e.message, error);
                        });

                    return p;
                }
            },
            onListarPoliza(event) {
                if (!_.isUndefined(event)) {
                    if (_.size(this.objeto.idSeguro) > 0) {
                        this.$set(this.listGeneral, 'listaPolizasModal', []);
                        this.$set(this.objForm, 'idSeguro', this.objeto.idSeguro);
                        var error = 'E';
                        var objeto = {
                            opcion: 'L_POLIZA',
                            idAseguradora: _.get(this.objeto, 'idAseguradora', null),
                            idSeguro: _.get(this.objeto, 'idSeguro', null),
                            idEstado: this.parametros.idEstadoDefault
                        };

                        var p = this.onListar(`administrador/producto/listar`, objeto)
                            .then((respuesta) => {
                                if (_.size(respuesta.data.data) == 0) {
                                    error = 'I';
                                    throw respuesta.data.mensaje;
                                }
                                this.$set(this.listGeneral, 'listaPolizasModal', respuesta.data.data);
                                return respuesta;
                            })

                        if (event instanceof Event)
                            p.catch((e) => {
                                mensajesAlerta(e || e.message, error);
                            });

                        return p;
                    }
                }
            },
            onListarIcono(event) {
                if (!_.isUndefined(event)) {
                    return this.onListar('administrador/repository-file/listar', {
                            'path': this.objeto.path
                        })
                        .then((respuesta) => {
                            this.$set(this.objeto, 'logo', _.size(respuesta.data.data) ? JSON.parse(JSON.stringify(
                                respuesta.data.data)) : null);
                            this.$forceUpdate();
                            return respuesta;
                        });
                }
            },
            validar() {
                if (this.$refs.form_datos_generales.validate()) {
                    if (!_.isUndefined(this.objForm.idProducto))
                        this.listGeneral.listaDatosGenerales = _.merge({}, this.objForm, this.objeto);
                    else
                        this.listGeneral.listaDatosGenerales = _.clone(this.objeto);
                    this.next();
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            },
            abrirVentana() {
                this.$refs.icono.click()
            },
            obtenerFile(e) {
                var file = e.target.files;
                try {
                    this.objeto.nombreIcono = null;
                    if (_.isUndefined(file[0])) throw mensajeEstandar.faltaArchivos;
                    if (file[0].name.lastIndexOf('.') <= 0) throw mensajeEstandar.archivo;
                    if (file[0].name.search('.png') == -1 && file[0].name.search('.jpg') == -1) throw mensajeEstandar
                        .archivo;

                    // window.iconoProducto = file;
                    const fr = new FileReader();
                    fr.readAsDataURL(file[0])
                    fr.addEventListener('load', () => {
                        this.$set(this.objeto, 'logo', fr.result);
                    });
                } catch (e) {
                    mensajesAlerta(e, 'E');
                }
            }
        }
    }
</script>